/**
 * OpenAI Ads Pixel — su kien phieu ban hang (page_viewed, contents_viewed, items_added).
 *
 * The base pixel nam trong layout/theme.liquid; file nay CHI ban su kien, khong bao gio goi init.
 * Du lieu Liquid di qua window.XILUGS_OAIQ (theme.liquid dat ngay truoc the <script src> nay).
 *
 * SCHEMA: chi dung truong co trong tai lieu cong khai cua OpenAI
 *   - su kien contents: { type:"contents", amount?, currency?, contents?[] }
 *   - Content:          { id?, name?, content_type?, quantity?, amount?, currency? }
 *   `group_id` va `variant_dict` tai lieu ghi "Conversions API only" -> KHONG dung o day.
 *   Tien la SO NGUYEN theo don vi nho nhat (ISO 4217). Gia cua Shopify trong Liquid va trong
 *   /cart/add.js DA la don vi nho nhat (cent) nen KHONG nhan chia gi them.
 *
 * KHONG ban page_viewed hai lan: do live 29/09, beacon tu dong cua SDK chi chua
 * `openai::sdk_init` + `oai::diagnostic`, KHONG co page_viewed. Nen ban tay o day la ban duy nhat.
 *
 * checkout_started: CHUA lam (chu shop hoan). Click vao nut checkout khong phai la Shopify da tao
 * checkout, va Shop Pay / PayPal di duong rieng khong qua nut do. Se lam bang su kien checkout
 * that cua Shopify.
 *
 * order_created: lam o SERVER qua Conversions API. Khoa API khong bao gio duoc xuat hien o day.
 */
(function () {
  'use strict';

  /* Nap hai lan (theme editor chen lai section) cung chi chay mot */
  if (window.__xilugsOaiqDaChay) return;
  window.__xilugsOaiqDaChay = true;

  var CF = window.XILUGS_OAIQ || {};
  var TIEN = CF.currency || '';

  function banRa(ten, payload) {
    if (typeof window.oaiq !== 'function') return;
    /* catch phai in TEN HAM ra, khong nuot im — bai hoc 19/09 (warmDong chet im vi catch tron) */
    try { window.oaiq('measure', ten, payload); }
    catch (e) { console.warn('openai-pixel-events: banRa ' + ten, e); }
  }

  /* Chi gan truong khi co gia tri that. Tien phai di KEM currency (tai lieu: currency bat buoc khi co amount). */
  function ganTien(o, soCent) {
    if (typeof soCent === 'number' && isFinite(soCent) && TIEN) { o.amount = soCent; o.currency = TIEN; }
    return o;
  }

  /* ---------- 1) page_viewed — moi trang ---------- */
  (function pageViewed() {
    var p = CF.page || {};
    var c = { content_type: 'page' };
    if (p.id) c.id = String(p.id);
    if (p.name) c.name = String(p.name);
    banRa('page_viewed', { type: 'contents', contents: [c] });
  }());

  /* ---------- 2) contents_viewed — chi trang san pham ----------
     Ban mot lan luc tai trang. Dawn khong dieu huong kieu SPA, va quick-add modal chi nap lai
     SECTION chu khong nap lai layout, nen khong co lan thu hai. */
  (function contentsViewed() {
    var s = CF.product;
    if (!s || !s.id) return;
    var c = { id: String(s.id), content_type: 'product' };
    if (s.name) c.name = String(s.name);
    ganTien(c, s.amount);
    banRa('contents_viewed', ganTien({ type: 'contents', contents: [c] }, s.amount));
  }());

  /* ---------- 3) items_added — chi sau khi Shopify xac nhan them thanh cong ---------- */

  /* Chong trung: khoa = key dong hang + so luong SAU khi them. Them lai dung bien the thi Shopify
     gop dong va so luong doi (1 -> 2) nen khoa khac -> lan them that thu hai VAN duoc tinh. */
  var daBan = Object.create(null);
  function trungKhoa(k) {
    if (!k) return false;
    if (daBan[k]) return true;
    daBan[k] = 1;
    setTimeout(function () { delete daBan[k]; }, 5000);
    return false;
  }

  function motMuc(it) {
    var c = { content_type: 'product' };
    /* Chu shop chot: dung VARIANT id lam Content.id (dung cap hang ban thuc te).
       Product id danh cho server-side qua `group_id` — truong do pixel trinh duyet khong co. */
    if (it.id != null) c.id = String(it.id);
    var ten = it.product_title || it.title;
    if (ten) c.name = String(ten);
    if (typeof it.quantity === 'number') c.quantity = it.quantity;
    ganTien(c, typeof it.final_price === 'number' ? it.final_price : it.price);
    return c;
  }

  function banThem(ds) {
    if (!ds || !ds.length) return;
    var contents = [], tong = 0, duTien = true;
    for (var i = 0; i < ds.length; i++) {
      var it = ds[i];
      if (!it || it.id == null) continue;
      if (trungKhoa((it.key || it.id) + ':' + it.quantity)) continue;
      contents.push(motMuc(it));
      var dong = typeof it.final_line_price === 'number' ? it.final_line_price
               : typeof it.line_price === 'number' ? it.line_price
               : (typeof it.final_price === 'number' && typeof it.quantity === 'number') ? it.final_price * it.quantity
               : null;
      if (dong === null) duTien = false; else tong += dong;
    }
    if (!contents.length) return;
    var payload = { type: 'contents', contents: contents };
    if (duTien) ganTien(payload, tong);   /* thieu gia mot dong thi bo han amount, khong doan */
    banRa('items_added', payload);
  }

  /* /cart/add.js tra ve: mot dong hang (co .id va .key), hoac { items: [...] } khi them nhieu. */
  function layMuc(cd) {
    if (!cd) return null;
    if (cd.id != null && cd.key != null) return [cd];
    if (Array.isArray(cd.items)) return cd.items;
    return null;
  }

  /* (a) Duong chuan cua Dawn: product-form.js chi publish SAU khi /cart/add.js tra ve khong loi.
     CHI nhan 'product-form' (quick-add modal cung chay qua day). KHONG nhan 'cart-items'
     (doi so luong trong gio) va 'external-refresh' (nap lai gio) — hai cai do khong phai "them hang". */
  function noiPubSub() {
    if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS) return false;
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (!e || e.source !== 'product-form') return;
      banThem(layMuc(e.cartData));
    });
    return true;
  }
  if (!noiPubSub()) {
    /* pubsub.js cung defer; neu file nay chay truoc thi doi den khi DOM xong roi noi lai. */
    document.addEventListener('DOMContentLoaded', noiPubSub, { once: true });
  }

  /* (b) Duong mua CHINH cua store: ba form custom (custom-strap-form, custom-strap-form-v2,
     custom-keyfob-form) la <form action="/cart/add"> THUAN, khong boc <product-form>, nen khong co
     PUB_SUB_EVENTS.cartUpdate. Nhung cstrap-engine.js / cstrap-engine-v2.js CO chan submit va tu
     fetch('/cart/add'); chung ban 'xilugs:cart-added' ngay SAU cho kiem `state.status`, tuc chi khi
     Shopify da nhan hang that.
     CON HUT mot duong: khi fetch loi, engine goi form.submit() (POST ca trang, trang unload) —
     luc do khong con JS nao de ban. Duong do chi order_created server-side moi dem duoc. */
  document.addEventListener('xilugs:cart-added', function (e) {
    banThem(layMuc(e && e.detail));
  });
}());
